<template>
  <div id="luckyDraw">
    <div class="content_box mb-4">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ clientPortalSettings.pageTitle || clientPortalSettings.title }}</h2>
          <p></p>
        </div>
        <div class="description_title mb-5 px-24 text-center">
          <p class="px-10 leading-relaxed vhtml_component" v-html="clientPortalSettings.description1"></p>
        </div>
        <div class="text-center">
          <div v-if="!optIn">
            <div class="text mb-4 description_title vhtml_component" v-html="clientPortalSettings.description2"></div>
            <TermsAndConditions
              :isAgreeTnc.sync="isAgreeTnc"
              :showError.sync="showTncError"
              :tncUrl="clientPortalSettings.tncLink"
            />
            <el-button type="primary" class="blue_button mb-4" data-testid="OptInNow" @click="handleOptIn()">
              {{ $t('promotion.common.optInNow') }}
            </el-button>
          </div>
          <div v-else>
            <div class="text mb-4 description_title vhtml_component" v-html="clientPortalSettings.description3"></div>
            <div class="mb-4">
              <a class="text_link" :href="clientPortalSettings.tncLink" target="_blank" data-testid="tnc">
                {{ $t('promotion.common.tnc') }}<i class="el-icon-arrow-right"></i>
              </a>
            </div>
            <div class="mb-4">
              <el-button
                type="primary"
                class="blue_button"
                data-testid="fund"
                @click="isTrade ? tradeNow() : fundNow()"
              >
                {{ isTrade ? $t('promotion.luckyDraw.tradeNow') : $t('promotion.luckyDraw.depositNow') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="px-10">
        <Progress v-if="optIn" :progressData="progressData" :isTrade="isTrade" class="mt-4"></Progress>
      </div>
    </div>
    <el-card shadow="never">
      <WinnerAnnouncement v-if="winnerList && winnerList.length > 0" :winnerList="winnerList" class="mb-5" />
      <Prizes v-if="prizeList && prizeList.length > 0" :prizeList="prizeList" :langUsed="langUsed" />
    </el-card>
  </div>
</template>

<script>
import OptInOut from '@/components/promotion/OptInOut';
import FAQ from '@/components/luckyDraw/FAQ.vue';
import Progress from '@/components/luckyDraw/Progress.vue';
import WinnerAnnouncement from '@/components/luckyDraw/WinnerAnnouncement.vue';
import Prizes from '@/components/luckyDraw/Prizes.vue';
import TermsAndConditions from '@/components/promotion/TermsAndConditions.vue';
import { apiCampaignInfo, apiCampaignOptStatus, apiCampaignGetDetails, apiCampaignOpt } from '@/resource';

export default {
  data() {
    return {
      optIn: false,
      clientPortalSettings: {},
      isAgreeTnc: false,
      showTncError: false,
      activityTab: 'faq',
      progressData: {},
      prizeList: [],
      winnerList: []
    };
  },
  components: { FAQ, Progress, WinnerAnnouncement, Prizes, TermsAndConditions, OptInOut },
  computed: {
    campaignID() {
      return parseInt(this.$route.params.campaignId) || null;
    },
    langUsed() {
      return this.$store.state.common.lang;
    },
    isTrade() {
      return this.progressData.accumulationMethod === 'trade';
    }
  },
  watch: {
    campaignID() {
      this.getData();
    }
  },
  methods: {
    async getData() {
      await apiCampaignInfo(this.campaignID, this.langUsed)
        .then(resp => {
          if (resp.data.code === 0) {
            this.optIn = resp.data.data.optIn;
            // CPS
            const tempCpSetting = resp.data.data.clientPortalSettings;
            this.clientPortalSettings = {
              ...tempCpSetting,
              document: tempCpSetting.document ? `${window.location.origin}/api${tempCpSetting.document}` : ''
            };
            this.$store.commit('promotion/setClientPortalLang', this.clientPortalSettings.languageCode);
            // Progress data
            this.progressData = {
              earnedTickets: resp.data.data.numberOfTicket,
              accumulationMethod: resp.data.data.accumulationMethod,
              totalTrade: resp.data.data.totalTrade,
              minimumTrade: resp.data.data.minimumTrade,
              totalDeposit: resp.data.data.totalDeposit,
              minimumDeposit: resp.data.data.minimumDeposit,
              depositType: resp.data.data.depositType
            };
            // Prize List
            this.prizeList = resp.data.data.prizeList;
            // Winner List
            this.winnerList = resp.data.data.winnerList;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    tradeNow() {
      window.open('https://protrader.vtms.live/', '_blank');
    },
    fundNow() {
      this.$router.push('/depositFunds');
    },
    handleOptIn() {
      if (this.isAgreeTnc) {
        this.showTncError = false;
        apiCampaignOpt(this.campaignID, true).then(resp => {
          if (resp.data.data) {
            this.$message({
              message: this.$t('promotion.common.optInSuccess'),
              type: 'success',
              duration: 5000
            });
            this.getData();
          } else {
            this.showError();
          }
        });
      } else {
        this.showTncError = true;
      }
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/promotion.scss';
#luckyDraw {
  .content_box {
    background-color: #fff;
    padding-bottom: 30px;
  }
  .description_title {
    font-weight: normal;
    font-size: 16px;
    color: $title-color;
  }
}
</style>
